module.exports = __webpack_public_path__ + "resources/img/img_passxpertv4_1.ddac859e6a90055d1d359284a10e716e.png";